export default "__VITE_ASSET__bkT3yZue__ 740w";